/**
 * Volume Chart Component
 *
 * Simple bar chart using CSS
 * Shows weekly training volume
 */

import './VolumeChart.css';

interface ChartData {
  label: string;
  value: number;
}

interface VolumeChartProps {
  data: ChartData[];
}

export function VolumeChart({ data }: VolumeChartProps): JSX.Element {
  const maxValue = Math.max(...data.map((d) => d.value));

  return (
    <div className="volume-chart">
      <div className="volume-chart__bars">
        {data.map((item) => {
          const heightPercent = maxValue > 0 ? (item.value / maxValue) * 100 : 0;

          return (
            <div key={item.label} className="volume-chart__bar-container">
              <div className="volume-chart__bar-wrapper">
                <div
                  className="volume-chart__bar"
                  style={{ height: `${heightPercent}%` }}
                >
                  {item.value > 0 && (
                    <span className="volume-chart__value">{item.value}</span>
                  )}
                </div>
              </div>
              <div className="volume-chart__label">{item.label}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
